import React from 'react';
import Layout from '../../layout/default';
import { Breadcrumb } from '../../components';

export const offer = ['/', 'Mes offres'];

// eslint-disable-next-line react/display-name
export const renderWithBreadcrumb = (Component, breadcrumb, keySelector) => (props) => {
  return (
    <Layout>
      {breadcrumb && <Breadcrumb value={breadcrumb}/>}
      <Component key={keySelector ? keySelector(props) : undefined}/>
    </Layout>
  );
};

// eslint-disable-next-line react/display-name
export const renderWithoutBreadcrumb = (Component, breadcrumb) => () => {
  return (
    // Do not add back `height: '100%'` nor `overflow: 'hidden'` here:
    // the content container was then capped to its parent height while the pages it
    // hosts (the document editor in particular) are taller. The overflow was clipped,
    // and above all only scrollable programmatically (`overflow: hidden` means no wheel,
    // yet `scrollTop` stays assignable): a `scrollIntoView` on any element of the page
    // made the header (breadcrumb, history button, title) disappear for good.
    // Without those two properties the container gets an automatic height and the window
    // is what scrolls, so everything stays reachable with the wheel.
    <Layout contentStyle={{ padding: '0' }}>
      <Component breadcrumb={breadcrumb}/>
    </Layout>
  );
};
